import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { theme } from './theme';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Issues from './pages/Issues';
import IssueDetail from './pages/IssueDetail';
import Authors from './pages/Authors';
import PublicationEthics from './pages/Authors/PublicationEthics';
import PublicationRules from './pages/Authors/PublicationRules';
import OpenAccess from './pages/Authors/OpenAccess';
import AuthorAgreement from './pages/Authors/AuthorAgreement';
import BorrowedMaterials from './pages/Authors/BorrowedMaterials';
import EditorialContact from './pages/Authors/EditorialContact';
import RoyaltyPayments from './pages/Authors/RoyaltyPayments';
import FAQ from './pages/Authors/FAQ';
import Contacts from './pages/Contacts';
import AdminDashboard from './pages/AdminDashboard';
import UserProfile from './pages/UserProfile';
import AuthorDashboard from './pages/AuthorDashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import ConfirmRegistration from './pages/ConfirmRegistration';
import EditorialBoard from './pages/EditorialBoard';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider } from './context/AuthContext';
import { ArticleProvider } from './context/ArticleContext';
import { IssueProvider } from './context/IssueContext';
import { AppProvider } from './context/AppContext';
import { UserProvider } from './context/UserContext';
import ProtectedRoute from './components/ProtectedRoute';
import { HelmetProvider } from 'react-helmet-async';
import PrivacyPolicy from './pages/PrivacyPolicy';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppProvider>
        <AuthProvider>
          <ArticleProvider>
            <IssueProvider>
              <UserProvider>
                <Routes>
                  <Route path="/" element={<Layout><Outlet /></Layout>}>
                    <Route index element={<Home />} />
                    <Route path="articles" element={<Articles />} />
                    <Route path="articles/:id/:slug" element={<ArticleDetail />} />
                    <Route path="issues" element={<Issues />} />
                    <Route path="issues/:id/:slug" element={<IssueDetail />} />
                    <Route path="authors" element={<Authors />} />
                    <Route path="authors/ethics" element={<PublicationEthics />} />
                    <Route path="authors/rules" element={<PublicationRules />} />
                    <Route path="authors/open-access" element={<OpenAccess />} />
                    <Route path="authors/agreement" element={<AuthorAgreement />} />
                    <Route path="authors/borrowed-materials" element={<BorrowedMaterials />} />
                    <Route path="authors/contact" element={<EditorialContact />} />
                    <Route path="authors/royalties" element={<RoyaltyPayments />} />
                    <Route path="authors/faq" element={<FAQ />} />
                    <Route path="editorial-board" element={<EditorialBoard />} />
                    <Route path="contacts" element={<Contacts />} />
                    <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="login" element={<Login />} />
                    <Route path="register" element={<Register />} />
                    <Route path="confirm-registration" element={<ConfirmRegistration />} />
                    <Route path="verify-email" element={<VerifyEmail />} />
                    <Route path="forgot-password" element={<ForgotPassword />} />
                    <Route path="reset-password" element={<ResetPassword />} />
                    <Route
                      path="admin/*"
                      element={
                        <ProtectedRoute roles={['admin', 'editor']}>
                          <AdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    {/* Личный кабинет обычных пользователей отключен */}
                    {/* <Route
                      path="profile"
                      element={
                        <ProtectedRoute>
                          <UserProfile />
                        </ProtectedRoute>
                      }
                    /> */}
                    <Route
                      path="author"
                      element={
                        <ProtectedRoute>
                          <AuthorDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Route>
                </Routes>
              </UserProvider>
            </IssueProvider>
          </ArticleProvider>
        </AuthProvider>
        </AppProvider>
        <Toaster position="top-right" />
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App; 